import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type OutputNodeType = Node<NodeData, 'custom_output'>;

export const OutputNode: React.FC<NodeProps<OutputNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const inputPort = (data.config?.input_port as string) || 'data';
  const outputName = data.config?.output_name as string;

  const subtitle = outputName ? `Name: ${outputName}` : undefined;

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="io"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Input handle for output blocks with connection indicators */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id={inputPort}
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, inputPort))
            : undefined
        }
      />
    </BaseNode>
  );
};
